<template>
  <div>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card flat tile id="Top_Scroll">
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">mdi-file-document-edit-outline</v-icon>카메라 대여 신청사항 수정
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="mr-4 ml-4"></v-divider>

        <v-card outlined tile class="ma-4" >
          <v-card-text class="mt-2 mb-2 pb-0">
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="CustomInfo.CustomNm" label="이름" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-if="editedItem.cLocal == 'Y'" v-model="editedItem.cCorpNmKor" label="업체명" dense disabled persistent-placeholder></v-text-field>
                <v-text-field v-else v-model="editedItem.cCorpNmEng" label="업체명" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="CustomInfo.Tel" label="전화번호" dense disabled persistent-placeholder></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>


        <v-card outlined tile class="ma-4 essetial_card">
          <v-card-text class="mt-2 mb-2 pb-0">
            <v-row>
              <v-col cols="12" sm="6" md="4">              
                <v-text-field class="ml-0 mb-0" style="height:20px; margin-top: 3px;"
                    v-model="editedItem.cDate" dense persistent-placeholder                    
                    append-icon="mdi-calendar"
                    readonly
                    @click:append="GetDate()"
                    placeholder="촬영일">
                    <template v-slot:label>
                      <div>촬영일<strong class="red--text">*</strong></div>
                    </template>
                  </v-text-field>              
            </v-col>  
            <v-col cols="12" sm="6" md="4">
              <v-select v-model="editedItem.cStart" :items="zStart" dense persistent-placeholder @change="GetCameraList('');">
                <template v-slot:label>
                  <div>대여요청시간<strong class="red--text">*</strong></div>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="4">
              <v-select v-model="editedItem.cEnd" :items="zEnd" dense persistent-placeholder @change="GetCameraList('');">
                <template v-slot:label>
                  <div>반납예정시간<strong class="red--text">*</strong></div>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <div v-if="zCamera.length == 0">

                <span v-if="isGetCameraList" class="text-sm-subtitle-2">사용가능한 카메라를 검색중 입니다.</span>                
                <span v-else-if="isTimeError" class="red--text text-sm-subtitle-2">유효하지 않은 대여시간입니다.</span>                
                <span v-else class="red--text text-sm-subtitle-2">선택할 수 있는 카메라가 없습니다.</span>                
              </div>
              <v-select v-else v-model="editedItem.cCameraId" :items="zCamera" dense persistent-placeholder placeholder="카메라 선택" >
                <template v-slot:label>
                  <div>카메라선택<strong class="red--text">*</strong></div>
                </template>
              </v-select>
            </v-col>
              <v-col cols="12" sm="6">
                <v-select v-model="editedItem.cPurpose" :items="zPicPurpose" dense persistent-placeholder>
                  <template v-slot:label>
                    <div>촬영목적<strong class="red--text">*</strong></div>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="editedItem.cInfo" dense auto-grow rows="1" persistent-placeholder>
                  <template v-slot:label>
                    <div>촬영내용<strong class="red--text">*</strong></div>
                  </template>                
                </v-textarea>
              </v-col>
              <v-col cols="12" class="pb-0">
                보안서약*<br>
                <p class="pl-2 pr-2 text-caption font-weight-bold">
                  상기 신청 내용에 한하여 촬영하고, 반·출입 절차를 준수하겠으며, 회사정보의 무단 반출 등으로 인한
                  <span class="red--text">일체의 책임</span>은
                  <span class="red--text">신청인에게 있음</span>에 동의합니다.
                </p>
              </v-col>
              <v-col cols="12" class="d-flex pt-0 pr-6 mt-n2">
                <v-spacer></v-spacer>
                <v-checkbox dense v-model="bAgree" color="black">
                  <template v-slot:label>
                    <div class="black--text">동의함</div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-divider class="ml-4 mr-4"></v-divider>
      </v-card>

      <v-card flat tile>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-text align="right" class="pa-3">
          <v-btn @click="dialog = false;" text width="90px" class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>닫기</v-btn>
          <v-btn @click="SetCameraPerLog()" dark width="90px" class="ml-2"><v-icon class="mr-2">save</v-icon>저장</v-btn>
        </v-card-text>
      </v-card>
      </v-dialog>

      <v-dialog v-model="isDate" width="290px">
        <v-card style="height: 440px;">        
          <v-date-picker
            color="black" 
            show-adjacent-months
            v-model="pickerDate"
            :min="minDate"
            locale="ko"          
            :day-format="(date) => new Date(date).getDate()">
            </v-date-picker>
          <div class="d-flex ma-3 mb-5">
            <v-spacer></v-spacer>
            <v-btn @click="isDate = false">취소</v-btn>
            <v-btn class="ml-2" @click="setDate()"><v-icon>mdi-check</v-icon> 확인</v-btn>
          </div>
        </v-card>
      </v-dialog>   
    
  </div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import { mapState } from "vuex";
import Util from "../Util.js";



export default {
  components: {

  },

  data: () => ({
    bAgree : false,
    sToday : Util.sFormatDate(Date()),
    minDate: new Date().toISOString().substr(0, 10),
    isGetCameraList : false,
    isTimeError : false,
    isDate : false,
    pickerDate : "",    
    dialog : false,
    
    zStart   : [    
      {value : "08:00:00", text : "08:00"},
      {value : "08:30:00", text : "08:30"},
      {value : "09:00:00", text : "09:00"},
      {value : "09:30:00", text : "09:30"},
      {value : "10:00:00", text : "10:00"},
      {value : "10:30:00", text : "10:30"},
      {value : "11:00:00", text : "11:00"},
      {value : "11:30:00", text : "11:30"},
      {value : "12:00:00", text : "12:00"},
      {value : "13:00:00", text : "13:00"},
      {value : "13:30:00", text : "13:30"},
      {value : "14:00:00", text : "14:00"},
      {value : "14:30:00", text : "14:30"},
      {value : "15:00:00", text : "15:00"},
      {value : "15:30:00", text : "15:30"},
      {value : "16:00:00", text : "16:00"},
      {value : "16:30:00", text : "16:30"},
      {value : "17:00:00", text : "17:00"},
      {value : "17:30:00", text : "17:30"},
      {value : "18:00:00", text : "18:00"},
    ],

    zEnd   : [    
      {value : "08:00:00", text : "08:00"},
      {value : "08:30:00", text : "08:30"},
      {value : "09:00:00", text : "09:00"},
      {value : "09:30:00", text : "09:30"},
      {value : "10:00:00", text : "10:00"},
      {value : "10:30:00", text : "10:30"},
      {value : "11:00:00", text : "11:00"},
      {value : "11:30:00", text : "11:30"},
      {value : "12:00:00", text : "12:00"},
      {value : "13:00:00", text : "13:00"},
      {value : "13:30:00", text : "13:30"},
      {value : "14:00:00", text : "14:00"},
      {value : "14:30:00", text : "14:30"},
      {value : "15:00:00", text : "15:00"},
      {value : "15:30:00", text : "15:30"},
      {value : "16:00:00", text : "16:00"},
      {value : "16:30:00", text : "16:30"},
      {value : "17:00:00", text : "17:00"},
      {value : "17:30:00", text : "17:30"},
      {value : "18:00:00", text : "18:00"},
    ],

    zCamera   : [],    
    EditIndex : -1,
    editedItem : {
      iCameraPerId : "",
      cCustomNm : "",
      cUserId : "",
      cUserNm : "",
      cPurpose : "",
      cZone    : "",
      cInfo    : "",
      cLocal   : "",
      cCorpNmKor : "",
      cCorpNmEng : "",      
      cStartDate : "",
      cEndDate : "",
    },
    zReqPicDeviceInfo : [],
    zReqPicSaveInfo : [],
    zMapZoneInfo : [],
    headers: [
      // { text: '품명 *', align: 'start', value: 'cProductNm',},
      // { text: '시리얼넘버 *', value: 'cSerialNum',},
      // { text: '용량 *', value: 'cVolume',},
      // { text: '수량(개) *', value: 'cCount',},
      // { text: '삭제', value: 'cDel',},
      { text: '품명 *', align: 'start', value: 'cProductNm',sortable : false},
      { text: '시리얼넘버 *', value: 'cSerialNum',sortable : false},
      { text: '용량 *', value: 'cVolume',sortable : false},
      { text: '수량(개) *', value: 'cCount',sortable : false},
      { text: '삭제', value: 'cDel',sortable : false},
    ],
    headers1: [
      { text: '품명', align: 'start', value: 'cProductNm',sortable : false},
      { text: '시리얼넘버', value: 'cSerialNum',sortable : false},
      { text: '용량', value: 'cVolume',sortable : false},
      { text: '수량(개)', value: 'cCount',sortable : false},
      { text: '삭제', value: 'cDel',sortable : false},
    ],

  }),
  computed: {
    ...mapState(["CustomInfo","zPicPurpose","zPicZone"]),
  },
  methods: {
    GetDate() {      
      this.isDate = true;
      this.pickerDate = this.editedItem.cDate;
    },

    setDate(){
      this.isDate = false;
      this.editedItem.cDate = this.pickerDate;

      this.GetCameraList("");
    },


    GetCameraList(id){
      this.zCamera = [];
      this.isTimeError = true;
      if (this.editedItem.cStart >= this.editedItem.cEnd){        
        return
      }

      this.isTimeError = false;
      this.isGetCameraList = true;
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CameraRentId : this.editedItem.cCameraRentId,
        cStartDateTime : this.editedItem.cDate + " " + this.editedItem.cStart,
        cEndDateTime : this.editedItem.cDate + " " + this.editedItem.cEnd,        
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "GetCameraList", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          this.isGetCameraList = false;
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {            
            this.zCamera = res.data.Result;

            if (this.zCamera.length > 0) {              
              if (id != "") {
                this.editedItem.cCameraId = id;
              } else {
                this.editedItem.cCameraId = this.zCamera[0].value;
              }
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          this.isGetCameraList = false;
          EventBus.$emit("onShowMsg",true, "GetCameraList:"+err);        
        });
    },

    // 다이올로그 창열렸을때
    ShowDialog(item,index){
      this.dialog = true;
      this.EditIndex = index;      
      this.bAgree = false;      
      this.editedItem.cCameraRentId = item.cCameraRentId;
      this.editedItem.cPurpose = item.cPurpose;
      this.editedItem.cInfo = item.cInfo;
      this.editedItem.cDate = item.cStartDate.substring(0,10);
      this.editedItem.cStart = item.cStartDate.substring(11,19);
      this.editedItem.cEnd = item.cEndDate.substring(11,19);
      this.editedItem.cCameraId = item.cCameraId;      
      
      this.GetCameraList(this.editedItem.cCameraId);
    },

    overmaxperiod(value){
      EventBus.$emit("onShowMsgBox", value.sTitle,value.sMsg);
    },

    // 날짜 변경하기
    onDateRangeChange(daterange){
      this.editedItem.cStartDate = Util.sFormatDate(daterange.startDate);
      this.editedItem.cEndDate = Util.sFormatDate(daterange.endDate);      
      this.editedItem.sNowSelectDate = this.editedItem.cStartDate + " ~ " +  this.editedItem.cEndDate;           
    },

    // 열 추가하기
    AddRow(state) {
      if (state == 1){
        this.zReqPicDeviceInfo.push({cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",});
      } else {
        this.zReqPicSaveInfo.push({cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",});
      }
    },

    // 열 삭제하기
    DelRow(state,row) {
      if (state == 1){
        let iDelIndex1 = this.zReqPicDeviceInfo.indexOf(row);
        if (iDelIndex1 != -1) {  
          this.zReqPicDeviceInfo.splice(iDelIndex1, 1);
        }
      } else {
        let iDelIndex2 = this.zReqPicSaveInfo.indexOf(row);
        if (iDelIndex2 != -1) {  
          this.zReqPicSaveInfo.splice(iDelIndex2, 1);
        }
      }
    },

    // 사진촬영 허가 수정하기
    SetCameraPerLog(){
      if (this.editedItem.cCameraId == ""){
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.", "카메라를 선택해주세요.");
        return
      }

      if (this.editedItem.cPurpose == null){
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.", "촬영 목적을 선택하여 주세요.");
        return
      }

      if (this.editedItem.cInfo == ""){
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.", "촬영 내용을 입력하여 주세요.");
        return
      }

      if (this.bAgree == false){
        EventBus.$emit("onShowMsgBox","보안서약에 대한 동의","보안서약에 동의해 주세요.");
        return
      }

      if (this.editedItem.cStart >= this.editedItem.cEnd){
        EventBus.$emit("onShowMsgBox", "확인", "카메라 대여 시간을 확인해주세요.");
        return
      }

      var posData = {
        CameraRentId : this.editedItem.cCameraRentId,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CustomNm : this.CustomInfo.CustomNm,
        CorpId : this.CustomInfo.CorpId,        
        UserNm : this.editedItem.cUserNm,
        cStartDateTime : this.editedItem.cDate + " " + this.editedItem.cStart,
        cEndDateTime : this.editedItem.cDate + " " + this.editedItem.cEnd,       
        CameraId : this.editedItem.cCameraId,
        Purpose : this.editedItem.cPurpose,
        Info : this.editedItem.cInfo,        
      };
      
      axios
        .post(process.env.VUE_APP_UIL_API + "SetCameraPerLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd == "00") {
            this.dialog = false;

            this.editedItem.cStartDate = this.editedItem.cDate + " " + this.editedItem.cStart;
            this.editedItem.cEndDate = this.editedItem.cDate + " " + this.editedItem.cEnd;

            this.$emit("ChangeCameraReq",this.editedItem,this.EditIndex)
            EventBus.$emit("onShowMsg",false,  "사진촬영 허가 요청이 완료되었습니다.");
          } else if (res.data.ResultCd == "02") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "초기화 버튼을 눌러서 상태를 확인해 주세요.");
            this.dialog = false;
          } else if (res.data.ResultCd == "55") {
            EventBus.$emit("onShowMsgBox","출입 정지 기간 중입니다.", res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>
